/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Visibilitypublicdescription2Inputs */

const zh_share_visibilitypublicdescription2 = /** @type {(inputs: Share_Visibilitypublicdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任何人都可以搜索和访问`)
};

const en_share_visibilitypublicdescription2 = /** @type {(inputs: Share_Visibilitypublicdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone on the web can find and access`)
};

const es_share_visibilitypublicdescription2 = /** @type {(inputs: Share_Visibilitypublicdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquiera en la web puede encontrar y acceder`)
};

/**
* | output |
* | --- |
* | "Anyone on the web can find and access" |
*
* @param {Share_Visibilitypublicdescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_visibilitypublicdescription2 = /** @type {((inputs?: Share_Visibilitypublicdescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Visibilitypublicdescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_visibilitypublicdescription2(inputs)
	if (locale === "en") return en_share_visibilitypublicdescription2(inputs)
	return es_share_visibilitypublicdescription2(inputs)
});
export { share_visibilitypublicdescription2 as "share_visibilityPublicDescription" }